// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-flex-container {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 3%;
  position: relative;
  flex-direction: row-reverse;
  padding-top: 0px;
  flex-direction: column;
}

.text-container {
  flex: 1 1;
}

.text-container p {
  max-width: 550px;
  color: #848484;
}

.modal-footer {
  justify-content: space-between;
}
.OtpPara {
  color: tomato;
  max-width: 200px;
}

.contact-left-image {
  flex: 1 1;
  margin-bottom: 0.5rem;
}
.contact-left-image img {
  width: 100%;
  height: auto;
}
.contact-form {
  /* font-weight: bold; */
}
.special_button {
  position: absolute;
  left: 100%;
}

.input-field {
  width: 100%;
  padding: 9px 20px;
  font-size: 14px;
  box-sizing: border-box;
  border: none;
  background-color: inherit;

  border-radius: 25px;
  border: 2px solid #477AF6;
}

select {
  color: black;
}
option {
  color: black;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}
.input-field::placeholder,
.input-field,
::placeholder,
::-webkit-input-placeholder,
:-ms-input-placeholder {
  color: gray;
}

.contact-form form {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 3rem;
}
textarea {
  grid-column: 1/-1;
  /* height: 100%; */
  background-color: inherit;
  border: none;
  color: black;
  border-radius: 25px;
  padding: 1.3rem;
  border: 2px solid #477AF6;
  font-size: 14px;
  resize: none !important;
}
.custom-shape-divider-bottom-1666093673 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.custom-shape-divider-bottom-1666093673 svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 150px;
}

.email_card {
  max-width: 478px;
  margin: 0px auto;
}
.otp_card {
  max-width: 650px;
  margin: 0px auto;
}

.custom-shape-divider-bottom-1666093673 .shape-fill {
  fill: #ffffff;
}
input[type="submit"] {
  color: white;
  background-color: #477AF6;
  font-size: 14px;
  padding: 11px;
  letter-spacing: 0.09em;
  border-radius: 50em !important;
  width: 11rem;
  border: none;
}

input[type="submit"]:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.react-tel-input .form-control {
  width: inherit;
  background-color: inherit;
  font-size: 14px;
  padding: 9px 14px 9px 48px;
  color: black;
  border: none;
  border-radius: 25px;
  border: 2px solid #477AF6;
}
.react-tel-input .form-control:focus {
  background-color: inherit;
  /* outline: none; */
  box-shadow: none;
  border: 2px solid #477AF6;
}
.contact-form #dropdown {
  padding: 14px;
}
.modal-body > h2 > div {
  justify-content: center;
}
.btn-link:focus {
  background-color: none !important;
}
.btn-link {
  text-decoration: none;
  display: block;
  width: 100%;
  text-align: center;
  color: black;
  font-weight: bold;
}
/* .modal-content {
    max-width: 650px;
  } */

#get-in-touch {
  color: #477AF6;
}
.long-input-container {
  grid-column: 1/-1;
}

#button:disabled,
#button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

@media only screen and (max-width: 724px) {
 
  input[type="submit"] {
    margin: 0 auto;
  }
  .contact-form {
    text-align: center;
  }
}

@media (min-width: 720px) {
  .contact-left-image img {
    width: 540px;
  }
  .email_card {
    padding: 2rem 2rem;
  }
}

@media (min-width: 1020px) {
  .contact-form {
    /* width: 100%; */
    max-width: 650px;
  }

  .contact-left-image img {
    width: 100%;
  }

  .contact-flex-container {
    flex-direction: row-reverse;
  }
  .contact-form form {
    width: 518px;
  }
}

/******************wave styling**************************/
.waves {
  position: relative;
  width: 100%;
  height: 70vh;
  margin-bottom: -7px; /*Fix for safari gap*/
  min-height: 100px;
  max-height: 150px;
  bottom: 149px;
}

.content {
  position: relative;
  height: 20vh;
  text-align: center;
  background-color: white;
}

/* Animation */
.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
  /* .waves { */
  /* height:40px;
        min-height:40px; */
}
.content {
  height: 30vh;
}
h1 {
  font-size: webkit-xxx-large;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/contact/components/ContactHome.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;EACP,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;;EAEzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;AACA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;;KAEK;;AAEL;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;AACF;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,qBAAqB;EAC1C,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,uEAAuE;AACzE;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;AACF;AACA,uBAAuB;AACvB;EACE,aAAa;EACb;0BACwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".contact-flex-container {\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  gap: 3%;\n  position: relative;\n  flex-direction: row-reverse;\n  padding-top: 0px;\n  flex-direction: column;\n}\n\n.text-container {\n  flex: 1;\n}\n\n.text-container p {\n  max-width: 550px;\n  color: #848484;\n}\n\n.modal-footer {\n  justify-content: space-between;\n}\n.OtpPara {\n  color: tomato;\n  max-width: 200px;\n}\n\n.contact-left-image {\n  flex: 1;\n  margin-bottom: 0.5rem;\n}\n.contact-left-image img {\n  width: 100%;\n  height: auto;\n}\n.contact-form {\n  /* font-weight: bold; */\n}\n.special_button {\n  position: absolute;\n  left: 100%;\n}\n\n.input-field {\n  width: 100%;\n  padding: 9px 20px;\n  font-size: 14px;\n  box-sizing: border-box;\n  border: none;\n  background-color: inherit;\n\n  border-radius: 25px;\n  border: 2px solid #477AF6;\n}\n\nselect {\n  color: black;\n}\noption {\n  color: black;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\n.input-field::placeholder,\n.input-field,\n::placeholder,\n::-webkit-input-placeholder,\n:-ms-input-placeholder {\n  color: gray;\n}\n\n.contact-form form {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n  margin-top: 3rem;\n}\ntextarea {\n  grid-column: 1/-1;\n  /* height: 100%; */\n  background-color: inherit;\n  border: none;\n  color: black;\n  border-radius: 25px;\n  padding: 1.3rem;\n  border: 2px solid #477AF6;\n  font-size: 14px;\n  resize: none !important;\n}\n.custom-shape-divider-bottom-1666093673 {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  line-height: 0;\n}\n\n.custom-shape-divider-bottom-1666093673 svg {\n  position: relative;\n  display: block;\n  width: calc(100% + 1.3px);\n  height: 150px;\n}\n\n.email_card {\n  max-width: 478px;\n  margin: 0px auto;\n}\n.otp_card {\n  max-width: 650px;\n  margin: 0px auto;\n}\n\n.custom-shape-divider-bottom-1666093673 .shape-fill {\n  fill: #ffffff;\n}\ninput[type=\"submit\"] {\n  color: white;\n  background-color: #477AF6;\n  font-size: 14px;\n  padding: 11px;\n  letter-spacing: 0.09em;\n  border-radius: 50em !important;\n  width: 11rem;\n  border: none;\n}\n\ninput[type=\"submit\"]:hover {\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.react-tel-input .form-control {\n  width: inherit;\n  background-color: inherit;\n  font-size: 14px;\n  padding: 9px 14px 9px 48px;\n  color: black;\n  border: none;\n  border-radius: 25px;\n  border: 2px solid #477AF6;\n}\n.react-tel-input .form-control:focus {\n  background-color: inherit;\n  /* outline: none; */\n  box-shadow: none;\n  border: 2px solid #477AF6;\n}\n.contact-form #dropdown {\n  padding: 14px;\n}\n.modal-body > h2 > div {\n  justify-content: center;\n}\n.btn-link:focus {\n  background-color: none !important;\n}\n.btn-link {\n  text-decoration: none;\n  display: block;\n  width: 100%;\n  text-align: center;\n  color: black;\n  font-weight: bold;\n}\n/* .modal-content {\n    max-width: 650px;\n  } */\n\n#get-in-touch {\n  color: #477AF6;\n}\n.long-input-container {\n  grid-column: 1/-1;\n}\n\n#button:disabled,\n#button[disabled] {\n  border: 1px solid #999999;\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n@media only screen and (max-width: 724px) {\n \n  input[type=\"submit\"] {\n    margin: 0 auto;\n  }\n  .contact-form {\n    text-align: center;\n  }\n}\n\n@media (min-width: 720px) {\n  .contact-left-image img {\n    width: 540px;\n  }\n  .email_card {\n    padding: 2rem 2rem;\n  }\n}\n\n@media (min-width: 1020px) {\n  .contact-form {\n    /* width: 100%; */\n    max-width: 650px;\n  }\n\n  .contact-left-image img {\n    width: 100%;\n  }\n\n  .contact-flex-container {\n    flex-direction: row-reverse;\n  }\n  .contact-form form {\n    width: 518px;\n  }\n}\n\n/******************wave styling**************************/\n.waves {\n  position: relative;\n  width: 100%;\n  height: 70vh;\n  margin-bottom: -7px; /*Fix for safari gap*/\n  min-height: 100px;\n  max-height: 150px;\n  bottom: 149px;\n}\n\n.content {\n  position: relative;\n  height: 20vh;\n  text-align: center;\n  background-color: white;\n}\n\n/* Animation */\n.parallax > use {\n  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;\n}\n.parallax > use:nth-child(1) {\n  animation-delay: -2s;\n  animation-duration: 7s;\n}\n.parallax > use:nth-child(2) {\n  animation-delay: -3s;\n  animation-duration: 10s;\n}\n.parallax > use:nth-child(3) {\n  animation-delay: -4s;\n  animation-duration: 13s;\n}\n.parallax > use:nth-child(4) {\n  animation-delay: -5s;\n  animation-duration: 20s;\n}\n@keyframes move-forever {\n  0% {\n    transform: translate3d(-90px, 0, 0);\n  }\n  100% {\n    transform: translate3d(85px, 0, 0);\n  }\n}\n/*Shrinking for mobile*/\n@media (max-width: 768px) {\n  /* .waves { */\n  /* height:40px;\n        min-height:40px; */\n}\n.content {\n  height: 30vh;\n}\nh1 {\n  font-size: webkit-xxx-large;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
